import React from "react"
import { OuterMenuItem } from "./OutMenuItem"
import { OuterMenuItemTypes } from "../CommandBar";
import { Box } from "@mui/material";

type OuterMenuListingType = {
    outerMenuItems: OuterMenuItemTypes[];
}

export const OuterMenuListing: React.FC<OuterMenuListingType> = ({
    outerMenuItems
}) => {
    return (
        <Box marginTop="12px">          
            {outerMenuItems.map((x, index) => (
                <OuterMenuItem 
                criteria={x.criteria}
                openSubMenu={x.openSubMenu}
                icon={x.icon}
                index={index}
                onClick={x.onClick}
                text={x.text}
                optionalIcon={x.optionalIcon}
                />
            ))}
        </Box>
    )
}